import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch } from "react";

export interface SapNumberFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  t: (key: string) => string;
}

export const SapNumberFilter = ({
  value = [],
  onChange,
  t,
}: SapNumberFilterProps) => {
  return (
    <ColorSearchAutocomplete
      label={t("filter_sap_number")}
      type="uvp"
      value={value}
      onChange={onChange}
    />
  );
};
